const attachments = {
  err_attachment_not_found: {
    message: 'Attachment not found',
  },
  err_candidate_message_not_found: {
    message: 'Message not found',
  },
  err_application_not_found: {
    message: 'Application not found',
  },
  err_attachment_not_found_in_message: {
    message: 'Candidate message not found',
  },
  err_attachment_already_exist: {
    message: 'Attachment already exists ',
  },
};

export default attachments;
